import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslate } from '../../../translations/hooks/useTranslate';
import { useStyles } from './styles';
import { Brand } from '../../../hooks/useSelectBrand';
import { useNavigate } from 'react-router-dom';

export const BrandsList: React.FC<{ setBrand: (brand: Brand) => void }> = ({ setBrand }) => {
  const t = useTranslate();
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={styles.container}>
      <Typography variant="h6" className={styles.heading}>
        {t('wiki.brands-list.title')}
      </Typography>
      <Button
        onClick={() => {
          setBrand(Brand.PH);
          navigate('/ph');
        }}
        className={styles.button}>
        Pizza Hut
      </Button>
      <Button
        onClick={() => {
          setBrand(Brand['PH-US']);
          navigate('/ph-us');
        }}
        className={styles.button}>
        Pizza Hut (US)
      </Button>
    </Box>
  );
};
